<div class="container pt-4 mb-4">
  <span class="font-gray-small">Atendimento</span>
  <div class="description-text description-text__blue pt-0 pb-2 pb-md-4">Fale Conosco</div>

  <form #form [formGroup]="ondeEncontrarForm">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <select
          formControlName="interesse"
          class="form-select"
          [class.error]="ondeEncontrarForm.controls['interesse'].errors?.['required'] && (ondeEncontrarForm.controls['interesse'].dirty || (ondeEncontrarForm.controls['interesse'].touched)|| submitted)"
          >
            <option disabled selected value="">O que você deseja</option>
            <option
              *ngFor="let option of optionsOQueDeseja"
              [value]="option.value"
            >
              {{ option.viewValue }}
            </option>
          </select>
          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['interesse'].errors?.['required'] && (ondeEncontrarForm.controls['interesse'].dirty || (ondeEncontrarForm.controls['interesse'].touched)|| submitted)"
          >
            Selecione um campo.
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <select
          formControlName="necessidade"
          class="form-select"
          [class.error]="ondeEncontrarForm.controls['necessidade'].errors?.['required'] && (ondeEncontrarForm.controls['necessidade'].dirty || (ondeEncontrarForm.controls['necessidade'].touched)|| submitted)">
            <option disabled selected value="">Quem sou?</option>
            <option
              *ngFor="let option of optionsQuemSou"
              [value]="option.value"
            >
              {{ option.viewValue }}
            </option>
          </select>
          <span
          class="text-danger"
          *ngIf="ondeEncontrarForm.controls['necessidade'].errors?.['required'] && (ondeEncontrarForm.controls['necessidade'].dirty || (ondeEncontrarForm.controls['necessidade'].touched)|| submitted)"
        >
          Selecione um campo.
        </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input
            class="form-control global-input-style"
            formControlName="cnpjCpf"
            mask="00.000.000/0000-00"
            type="text"
            placeholder="CNPJ"
            [class.error]="
              ondeEncontrarForm.controls['cnpjCpf'].errors &&
              (ondeEncontrarForm.controls['cnpjCpf'].dirty ||
                ondeEncontrarForm.controls['cnpjCpf'].touched ||
                submitted)
            "
          />

          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['cnpjCpf'].errors?.['required'] && (ondeEncontrarForm.controls['cnpjCpf'].dirty || (ondeEncontrarForm.controls['cnpjCpf'].touched || submitted))"
          >
            CNPJ é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!ondeEncontrarForm.controls['cnpjCpf'].errors?.['required'] && (ondeEncontrarForm.controls['cnpjCpf'].dirty || (ondeEncontrarForm.controls['cnpjCpf'].touched)|| submitted) && ondeEncontrarForm.controls['cnpjCpf'].errors"
          >
            CNPJ inválido.
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            class="form-control global-input-style"
            formControlName="nome"
            type="text"
            name="nome"
            (change)="saverange($event, 'nome')"
            placeholder="Nome"
            [class.error]="
              ondeEncontrarForm.controls['nome'].errors &&
              (ondeEncontrarForm.controls['nome'].dirty ||
                ondeEncontrarForm.controls['nome'].touched ||
                submitted)
            "
          />

          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['nome'].errors?.['required'] && (ondeEncontrarForm.controls['nome'].dirty || (ondeEncontrarForm.controls['nome'].touched) || submitted)"
          >
            Nome é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!ondeEncontrarForm.controls['nome'].errors?.['required'] && (ondeEncontrarForm.controls['nome'].dirty || (ondeEncontrarForm.controls['nome'].touched) || submitted) && ondeEncontrarForm.controls['nome'].errors"
          >
            Nome inválido.
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input
            class="form-control global-input-style"
            formControlName="email"
            type="text"
            placeholder="E-mail"
            (change)="saverange($event, 'email')"
            [class.error]="
              ondeEncontrarForm.controls['email'].errors &&
              (ondeEncontrarForm.controls['email'].dirty ||
                ondeEncontrarForm.controls['email'].touched ||
                submitted)
            "
          />

          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['email'].errors?.['required'] && (ondeEncontrarForm.controls['email'].dirty || (ondeEncontrarForm.controls['email'].touched)|| submitted)"
          >
            E-mail é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!ondeEncontrarForm.controls['email'].errors?.['required'] && (ondeEncontrarForm.controls['email'].dirty || (ondeEncontrarForm.controls['email'].touched)|| submitted) && ondeEncontrarForm.controls['email'].errors"
          >
            E-mail inválido.
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            class="form-control global-input-style"
            formControlName="telefone"
            type="text"
            mask="(00)0000-0000 || (00)00000-0000 "
            placeholder="Telefone"
            [class.error]="
              ondeEncontrarForm.controls['telefone'].errors &&
              (ondeEncontrarForm.controls['telefone'].dirty ||
                ondeEncontrarForm.controls['telefone'].touched ||
                submitted)
            "
          />
          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['telefone'].errors?.['required'] && (ondeEncontrarForm.controls['telefone'].dirty || (ondeEncontrarForm.controls['telefone'].touched)|| submitted)"
          >
            Telefone é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!ondeEncontrarForm.controls['telefone'].errors?.['required'] && (ondeEncontrarForm.controls['telefone'].dirty || (ondeEncontrarForm.controls['telefone'].touched)|| submitted) && ondeEncontrarForm.controls['telefone'].errors"
          >
            Telefone inválido.
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <select
            class="form-select"
            formControlName="estado"
            [class.error]="ondeEncontrarForm.controls['estado'].errors?.['required'] && (ondeEncontrarForm.controls['estado'].dirty || (ondeEncontrarForm.controls['estado'].touched)|| submitted)"
          >
            <option
              value=""
              disabled
              [selected]="!ondeEncontrarForm.controls['estado'].value"
            >
              Selecione um estado
            </option>
            <option *ngFor="let estado of listaEstados" [value]="estado.nome">
              {{ estado.nome }}
            </option>
          </select>
          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['estado'].errors?.['required'] && (ondeEncontrarForm.controls['estado'].dirty || (ondeEncontrarForm.controls['estado'].touched)|| submitted)"
          >
            Selecione um estado.
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <select
            class="form-select"
            formControlName="cidade"
            [class.error]="ondeEncontrarForm.controls['cidade'].errors?.['required'] && (ondeEncontrarForm.controls['cidade'].dirty || (ondeEncontrarForm.controls['cidade'].touched)|| submitted)"
          >
            <option
              value=""
              *ngIf="ondeEncontrarForm.controls['estado'].errors"
            >
              Selecione um estado primeiro
            </option>
            <option
              value=""
              [selected]="!ondeEncontrarForm.controls['cidade'].value"
              *ngIf="!ondeEncontrarForm.controls['estado'].errors"
            >
              Selecione uma cidade
            </option>
            <option *ngFor="let cidade of listaCidades[0]" [value]="cidade">
              {{ cidade }}
            </option>
          </select>
          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['cidade'].errors?.['required'] && (ondeEncontrarForm.controls['cidade'].dirty || (ondeEncontrarForm.controls['cidade'].touched)|| submitted)"
          >
            Selecione a cidade.
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="form-group">
        <input
          class="form-control global-input-style"
          type="text"
          formControlName="endereco"
          (change)="saverange($event, 'endereco')"
          placeholder="Endereço"
          [class.error]="
            ondeEncontrarForm.controls['endereco'].errors &&
            (ondeEncontrarForm.controls['endereco'].dirty ||
              ondeEncontrarForm.controls['endereco'].touched ||
              submitted)
          "
        />

        <span
          class="text-danger"
          *ngIf="ondeEncontrarForm.controls['endereco'].errors?.['required'] && (ondeEncontrarForm.controls['endereco'].dirty || (ondeEncontrarForm.controls['endereco'].touched)|| submitted)"
        >
          Endereço é necessário.
        </span>
        <span
          class="text-danger"
          *ngIf="!ondeEncontrarForm.controls['endereco'].errors?.['required'] && (ondeEncontrarForm.controls['endereco'].dirty || (ondeEncontrarForm.controls['endereco'].touched)|| submitted) && ondeEncontrarForm.controls['endereco'].errors"
        >
          Endereço inválido.
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input
            class="form-control global-input-style"
            formControlName="bairro"
            type="text"
            placeholder="Bairro"
            (change)="saverange($event, 'bairro')"
            [class.error]="
              ondeEncontrarForm.controls['bairro'].errors &&
              (ondeEncontrarForm.controls['bairro'].dirty ||
                ondeEncontrarForm.controls['bairro'].touched ||
                submitted)
            "
          />

          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['bairro'].errors?.['required'] && (ondeEncontrarForm.controls['bairro'].dirty || (ondeEncontrarForm.controls['bairro'].touched)|| submitted)"
          >
            Bairro é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!ondeEncontrarForm.controls['bairro'].errors?.['required'] && (ondeEncontrarForm.controls['bairro'].dirty || (ondeEncontrarForm.controls['bairro'].touched)|| submitted) && ondeEncontrarForm.controls['bairro'].errors"
          >
            Bairro inválido.
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            class="form-control global-input-style"
            formControlName="cep"
            type="text"
            mask="00000-000"
            placeholder="CEP"
            [class.error]="
              ondeEncontrarForm.controls['cep'].errors &&
              (ondeEncontrarForm.controls['cep'].dirty ||
                ondeEncontrarForm.controls['cep'].touched ||
                submitted)
            "
          />
          <span
            class="text-danger"
            *ngIf="ondeEncontrarForm.controls['cep'].errors?.['required'] && (ondeEncontrarForm.controls['cep'].dirty || (ondeEncontrarForm.controls['cep'].touched)|| submitted)"
          >
            CEP é necessário.
          </span>
          <span
            class="text-danger"
            *ngIf="!ondeEncontrarForm.controls['cep'].errors?.['required'] && (ondeEncontrarForm.controls['cep'].dirty || (ondeEncontrarForm.controls['cep'].touched)|| submitted) && ondeEncontrarForm.controls['cep'].errors"
          >
            CEP inválido.
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <textarea class="form-control" id="mensagem" formControlName="mensagem"  rows="12" style="resize: none;"
        placeholder="Mensagem" (change)="saverange($event, 'mensagem')"     (input)="contarCaracteres($event)"
        [class.error]="ondeEncontrarForm.controls['mensagem'].errors && (ondeEncontrarForm.controls['mensagem'].dirty || (ondeEncontrarForm.controls['mensagem'].touched)|| submitted)"></textarea>

      <span class="text-danger"
        *ngIf="ondeEncontrarForm.controls['mensagem'].errors?.['required'] && (ondeEncontrarForm.controls['mensagem'].dirty || (ondeEncontrarForm.controls['mensagem'].touched)|| submitted)">
        Mensagem é necessária.
      </span>
      <span class="text-danger"
        *ngIf="!ondeEncontrarForm.controls['mensagem'].errors?.['required'] && (ondeEncontrarForm.controls['mensagem'].dirty || (ondeEncontrarForm.controls['mensagem'].touched)|| submitted) && ondeEncontrarForm.controls['mensagem'].errors">
        Mensagem inválido. {{quantidadeCaracteres}} caractere(s) restante(s).
      </span>
      </div>
    </div>
  </form>
  <div class="row mt-4">
    <div class="col-md-7">
      <div class="mb-3">
        <p class="font-gray-small min-area-form">
          Opção de envio de imagem ou arquivo <br />(JPG, PNG, PDF, DOC e DOCX)
        </p>
        <button
          type="button"
          (click)="anexarArquivo.click(); $event.preventDefault()"
          class="btn-ver-mais w-100 mb-2"
        >
          ANEXAR ARQUIVO
        </button>
        <input
          class="d-none"
          id="anexarArquivo"
          type="file"
          #anexarArquivo
          (change)="onFileSelect($event)"
          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx"
        />
        <div *ngIf="fileTemp">
          Arquivo selecionado: {{ fileTemp.name }}
        </div>
      </div>

    </div>
    <div class="col-md-5">
      <div class="mb-2 mt-2 min-area-form">
        <div class="form-check form-check-inline mb-3">
          <input
            (change)="aceitaReceberEmail($event)"
            class="form-check-input"
            type="checkbox"
            id="check"
          />
          <label class="form-check-label font-gray-small" for="check"
            >Desejo receber novidades e informações da Blukit em meu e-mail</label
          >
        </div>

      </div>

      <button [disabled]="submitted" class="btn-submit-form mb-2 mt-3" (click)="onSubmit('Fale Conosco')">Enviar</button>
    </div>
  </div>
  <hr class="mt-4" />
  <div class="description-text description-text__blue pt-2 pb-0">
    Localização da Blukit
  </div>
  <span class="font-gray-small">
    Blukit - Rua João Pessoa, 2566 - Bairro da Velha - Blumenau / SC
  </span>
</div>
<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2097.8877293025976!2d-49.09838206064691!3d-26.919997079216962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94df1936d4017a6f%3A0x1cdad94ded8248b1!2sR.%20Jo%C3%A3o%20Pessoa%2C%202566%20-%20Velha%2C%20Blumenau%20-%20SC%2C%2089036-004!5e0!3m2!1spt-BR!2sbr!4v1685041340840!5m2!1spt-BR!2sbr"
  style="border: 0; width: 100%; height: auto; min-height: 300px"
  allowfullscreen=""
  loading="lazy"
  referrerpolicy="no-referrer-when-downgrade"
></iframe>
